import type { AssessmentResultStore } from './interfaces'

import { createInitialState } from './state'

export const actions = {
  resetState (this: AssessmentResultStore): void {
    Object.assign(this, createInitialState())
  },
  setQuestions (this: AssessmentResultStore, payload: AssessmentResultStore['questions']): void {
    this.questions = payload
  },
  setComprehension (this: AssessmentResultStore, payload: AssessmentResultStore['comprehension']): void {
    this.comprehension = payload
  },
  setScore (this: AssessmentResultStore, payload: AssessmentResultStore['score']): void {
    this.score = payload
  },
  setVariant (this: AssessmentResultStore, payload: AssessmentResultStore['variant']): void {
    this.variant = payload
  },
  setAssessmentId (this: AssessmentResultStore, payload: AssessmentResultStore['id']): void {
    this.id = payload
  },
  setAssessmentUrls (this: AssessmentResultStore, payload: AssessmentResultStore['assessmentUrls']): void {
    this.assessmentUrls = payload
  },
  begin (this: AssessmentResultStore, id: number): number {
    if (id !== this.activeId) {
      this.id = null
      this.questions = []
      this.comprehension = false
      this.score = 0
      this.activeId = id
    }

    this.requestId += 1
    this.status = 'loading'

    return this.requestId
  },
  settle (this: AssessmentResultStore, id: number, requestId: number): void {
    if (id !== this.activeId || requestId !== this.requestId) return

    this.status = 'ready'
  },
  fail (this: AssessmentResultStore, id: number, requestId: number): void {
    if (id !== this.activeId || requestId !== this.requestId) return

    this.status = 'error'
  },
}
